/* eslint-disable camelcase */

import { SWRConfiguration } from "swr";
import { ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosHVS";

export interface SettingsDomainApiResponse<T> {
  data: T;
}

export interface SettingsDomain {
  time: {
    timezone: string;
    utc_offset: number;
  };

  map: {
    start_x: number;
    start_y: number;
    zoom_factor: number;
  };
}

export const useSettingsDomain = (
  config: SWRConfiguration
): ServerResponse<SettingsDomainApiResponse<SettingsDomain>> =>
  useSwr<SettingsDomainApiResponse<SettingsDomain>>(`/settings/domain`, config);
